import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { 
  Users, FileText, Building2, LogOut, Home, Settings 
} from "lucide-react";

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: Home, path: '/portal/dashboard' },
  { id: 'patients', label: 'Patients', icon: Users, path: '/portal/patients' },
  { id: 'requests', label: 'Requests', icon: FileText, path: '/portal/requests' },
  { id: 'settings', label: 'Settings', icon: Settings, path: '/portal/settings' },
];

export default function PortalSidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const getActivePage = () => {
    const path = location.pathname;
    if (path.includes('/patients')) return 'patients';
    if (path.includes('/requests')) return 'requests';
    if (path.includes('/settings')) return 'settings';
    return 'dashboard';
  };

  const activePage = getActivePage();

  return (
    <aside className="w-64 bg-white border-r border-slate-200 flex flex-col" data-testid="portal-sidebar">
      <div className="p-6 border-b border-slate-200">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center">
            <Building2 size={20} className="text-white" />
          </div>
          <div>
            <p className="font-bold text-slate-900 text-sm">Client Portal</p>
            <p className="text-xs text-slate-500 truncate max-w-[140px]">
              {user?.email || 'Welcome'}
            </p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1" data-testid="portal-nav">
        {navItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            data-testid={`portal-nav-${item.id}`}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg font-medium text-sm transition-colors ${
              activePage === item.id
                ? "bg-emerald-50 text-emerald-700"
                : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            <item.icon size={18} />
            {item.label}
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-200">
        <button
          onClick={handleLogout}
          data-testid="portal-logout"
          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-red-600 hover:bg-red-50 font-medium text-sm transition-colors w-full"
        >
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
